// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"336":"17c0d37c","659":"3c82a4d3","787":"9eaa9f11","821":"2ec405bf"}[chunkId] + ".chunk.js";
};